module.exports = require('./abstract-annual-report').extend({
    setupController: function(controller) {
        controller.set('model', this.modelFor('annual_report'))
    }
})
